export default __webpack_public_path__ + "static/media/element_53.b6aa1844.webp";